// export const SERVER_HOSTNAME = 'http://14.248.147.45:3000'
// export const SERVER_HOSTNAME = 'http://192.168.100.7:3000'
// export const SERVER_HOSTNAME = 'http://192.168.1.100:3000'
export const SERVER_HOSTNAME = 'https://drk-cloud.com'
// export const SERVER_HOSTNAME = 'http://localhost:3000'